import { EPaymentMethod } from "features/common/types";
import { ISelectBankTransferPaymentResponse } from "../types";

export const mockSelectBankTransferPaymentResponse: ISelectBankTransferPaymentResponse = {
  result: {
    method: EPaymentMethod.BankTransfer,
    draft: null,
    updatedAt: "2025-09-16T12:34:56.789Z"
  },
  isSuccess: true,
  message: null,
  validationIssues: null
};
